import React from "react";
import { ListRoleInProject } from "./components/List";

export default function RoleInProject() {
  return <ListRoleInProject />;
}
